import React, { Component } from 'react';
import Translation from '../../../../../../common/translation/translation.component';
import { HistoryLayout } from '../../../../../../common/history/history-layout.component';
import { MODAL_CUSTOM_MESSAGE } from '../../../../../../../constants/external-constants';
import CostAllocationHistory from './cost-allocation.history.component';
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { glCodeHistoryActions } from '../../../../../../../store/external/finance/glcode-details/gl-code-history.reducer'
import { costCenterHistoryActions } from '../../../../../../../store/external/finance/history/cost-center-history.reducer'
class CostAllocationHistoryLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: "0",
            enableSearchBox: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
        };
    }

    displaySearchBox = (value) => {
        this.setState({ enableSearchBox: value })
    }

    getSelectedIndex(value) {
        this.setState({ selectedIndex: value })
    }

    onClickExtract = () => {

        const { glCodeId, extracGlCodeHistoryLogs, extracCostCodeHistoryLogs, costCodeId } = this.props;
        if (this.props.glCodeId) {
            if (window.confirm(this.state.exportAlertMsg)) {
                extracGlCodeHistoryLogs(glCodeId);
            }
        }
        if (this.props.costCodeId) {
            if (window.confirm(this.state.exportAlertMsg)) {
                extracCostCodeHistoryLogs(costCodeId);
            }
        }
    }  

    render() {
        const { isReadOnly, isReadAndExtractOnly, isReadAndWrite } = this.props;
        return (
            <>
                <Translation
                    getOnlyText={true}
                    onChangeTranslation={() => { }}
                    translationKey={"export_alert_message"} />

                <HistoryLayout
                    listHistoryTab={this.props.listHistoryTab}
                    selectedIndex={[]}
                    extractAction={this.onClickExtract}
                    displaySearchBox={this.displaySearchBox}
                    hideCustomColumn={this.props.hideCustomColumn}

                    isReadOnly={isReadOnly}
                    isReadAndExtractOnly={isReadAndExtractOnly}
                    isReadAndWrite={isReadAndWrite}
                >
                   
                 <CostAllocationHistory
                        glCodeId={this.props.glCodeId}
                        costCodeId={this.props.costCodeId}
                     isColSearchShow={this.state.enableSearchBox}
                     costAllocationType={this.props.costAllocationType}
                 />
                </HistoryLayout>
            </>
        );
    }
}


export default connect(
    state => {
        const { } = state;

        return {

        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, glCodeHistoryActions, costCenterHistoryActions),
        dispatch
    )
)(CostAllocationHistoryLayout);